import { Avatar, AvatarProps, styled } from "@mui/material";
import { FC } from "react";

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  borderColor: theme.palette.divider,
    ...theme.applyStyles("light", {borderColor: theme.palette.secondary[300]}),
  backgroundColor: theme.palette.primary[200],
    ...theme.applyStyles("light", {backgroundColor: theme.palette.secondary[300]}),
  }));

const SupportAvatar: FC<AvatarProps> = (props) => {
  return <StyledAvatar {...props} />;
};

export default SupportAvatar;
